import { useQuery } from '@apollo/client'
import { CurrentUserInfoQuery } from '@deltek/specification-client/core/GraphQL/Queries/currentUserInfo.queries'
import { CurrentUserInfoResponse } from '@deltek/specification-client/core/Models/currentUserInfo'
import { FirmUserResponse, User } from '@deltek/specification-client/core/Models/user'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { UserProfileQuery } from 'api/graphQL/queries/userProfile.queries'
import React from 'react'
import { useParams } from 'react-router-dom'

const title = 'Contact Details'

const useStyles = makeStyles({
    spacing: {
        paddingTop: "10px",
    }
})
const ContactDetailsPage = () => {
    const classes = useStyles()
    const { id } = useParams<{ id?: string }>()
    const { data: currentUserInfoResponse } = useQuery<CurrentUserInfoResponse>(
        CurrentUserInfoQuery
    )
    const { data } = useQuery<FirmUserResponse>(UserProfileQuery, {
        variables: {
            firmId:
                currentUserInfoResponse?.currentUserInfo?.account?.accountId ??
                '',
            userId: id ?? '',
        },
    })

    const contact: Partial<User> | undefined = data?.user
    return (
        <div className="App" data-testid="contactDetailsPage">
            <header className="App-header">
                <Typography variant="h1">{title}</Typography>

                <div className={classes.spacing}>
                    Email: {contact?.email}
                    <br />
                    First Name: {contact?.profileInfo?.firstName}
                    <br />
                    Last Name: {contact?.profileInfo?.lastName}
                    <br />
                    Contact #: {contact?.profileInfo?.phone}
                </div>
            </header>
        </div>
    )
}

export default ContactDetailsPage
